{
  "emptyState": "No pending FAA approvals",
  "unknown": "Unknown",
  "headers": {
    "tailNumber": "Tail Number",
    "aircraftType": "Aircraft Type",
    "fbo": "FBO",
    "submittedBy": "Submitted By",
    "submitted": "Submitted",
    "tenant": "Tenant",
    "actions": "Actions"
  },
  "tenant": {
    "created": "Created",
    "noTenant": "No tenant"
  },
  "errors": {
    "missingData": "Cannot approve: aircraft data missing. Try refreshing.",
    "createFaaTail": "Failed to create FAA tail entry: {{message}}",
    "createFaaMapping": "Failed to create FAA mapping: {{message}}",
    "markApproved": "Failed to mark as approved: {{message}}",
    "approveFailed": "Failed to approve. Please try again.",
    "rejectFailed": "Failed to reject. Please try again."
  },
  "success": {
    "approved": "Approved FAA mapping for {{tailNumber}} → {{make}} {{model}}",
    "rejected": "Rejected approval request for {{tailNumber}}"
  }
}
